import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Rewards from './views/Rewards.vue'
// import SalesForm from './views/SalesForm.vue'
import BranchExpenses from './views/BranchExpenses.vue'
import Portal from './views/Portal.vue'
import Admin from './views/Admin.vue'
import AdminSaleEdit from './views/AdminSaleEdit.vue'
import History from '@/views/History.vue'


const IncentivesDashboard = Dashboard
const IncentivesRewards = Rewards
// const IncentivesSalesForm = SalesForm

Vue.use(Router)

// ---- Role groups (FINAL VISION / BACKEND ENUM) ----
var SALES_ROLES = ['sales_employee', 'branch_manager', 'branch_admin', 'super_admin']
var BIRD_EYE_ROLES = ['branch_manager', 'branch_admin', 'super_admin']

var OPS_FINANCE_ROLES = ['finance', 'super_admin']
var OPS_DISPATCH_ROLES = ['dispatch', 'super_admin']
var OPS_INSTALLER_ROLES = ['installer', 'super_admin']
var OPS_RM_STORE_ROLES = ['rm_store', 'super_admin']

// History should be visible to everyone except rm_store (as you asked)
var HISTORY_ROLES = [
  'sales_employee','branch_manager','branch_admin','super_admin',
  'finance','dispatch','installer'
]

// Incentives should be accessible by: Installer + Sales + BM + BA + SA
var INCENTIVES_ROLES = ['sales_employee', 'branch_manager', 'branch_admin', 'super_admin', 'installer']


// Everyone who can use messaging (practical)
var ALL_ALLOWED = [
  'sales_employee', 'branch_manager', 'branch_admin', 'super_admin',
  'finance', 'dispatch', 'installer', 'rm_store'
]

function roleHomePath (role) {
  if (!role) return '/portal/sales/dashboard'

  // Sales side (includes BM/BA/SA)
  if (role === 'sales_employee' || role === 'branch_manager' || role === 'branch_admin' || role === 'super_admin') {
    return '/portal/sales/dashboard'
  }

  // Ops portals
  if (role === 'finance') return '/portal/ops/finance'
  if (role === 'dispatch') return '/portal/ops/dispatch'
  if (role === 'installer') return '/portal/ops/installer'
  if (role === 'rm_store') return '/portal/ops/rm-store/dashboard'

  return '/portal/sales/dashboard'
}

var router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'login', component: Login },

    {
      path: '/portal',
      component: Portal,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: function () {
            var u = store.getters['auth/currentUser'] || {}
            return roleHomePath(u.role || null)
          }
        },

        // =========================
        // SALES (CRM)
        // =========================
        {
          path: 'sales/dashboard',
          name: 'sales-dashboard',
          component: function () { return import('./views/Sales/SalesDashboard.vue') },
          meta: { allowedRoles: SALES_ROLES }
        },
        {
          path: 'sales/customers',
          name: 'sales-customers',
          component: function () { return import('./views/Sales/SalesCustomers.vue') },
          meta: { allowedRoles: SALES_ROLES }
        },
        {
          path: 'sales/customers/:id',
          name: 'sales-customer-detail',
          component: function () { return import('./views/Sales/SalesCustomerDetail.vue') },
          meta: { allowedRoles: SALES_ROLES }
        },
        {
          path: 'sales/quotations',
          name: 'sales-quotations',
          component: function () { return import('./views/Sales/SalesQuotations.vue') },
          meta: { allowedRoles: SALES_ROLES }
        },
        {
          path: 'sales/orders/:id',
          name: 'sales-order-detail',
          component: function () { return import('./views/Sales/SalesOrderDetail.vue') },
          props: true,
          meta: { allowedRoles: SALES_ROLES }
        },
        {
          path: 'sales/followups',
          name: 'sales-followups',
          component: function () { return import('./views/Sales/SalesFollowups.vue') },
          meta: { allowedRoles: SALES_ROLES }
        },

        {
          path: 'sales/history',
          name: 'sales-history',
          component: History,
          meta: { allowedRoles: SALES_ROLES }
        },


        // Birds-eye CRM (BM/Admin/Super)
        {
          path: 'admin/crm',
          name: 'admin-crm',
          component: function () { return import('./views/Admin/AdminCRM.vue') },
          meta: { allowedRoles: BIRD_EYE_ROLES }
        },

        // =========================
        // MESSAGES (everyone)
        // =========================
        {
          path: 'messages',
          name: 'messages-inbox',
          component: function () { return import('./views/Messages/Inbox.vue') },
          meta: { allowedRoles: ALL_ALLOWED }
        },
        {
          path: 'messages/new',
          name: 'messages-compose',
          component: function () { return import('./views/Messages/Compose.vue') },
          meta: { allowedRoles: ALL_ALLOWED }
        },

        // =========================
        // INCENTIVES (kept)
        // =========================
        {
          path: 'sales/incentives',
          component: { render: function (h) { return h('router-view') } },
          meta: { requiresAuth: true, allowedRoles: INCENTIVES_ROLES, mode: 'incentives' },
          children: [
            { path: '', redirect: 'dashboard' },
            { path: 'dashboard', name: 'incentives-dashboard', component: IncentivesDashboard },
            { path: 'rewards', name: 'incentives-rewards', component: IncentivesRewards },
            // { path: 'sales/new', name: 'incentives-sales-new', component: IncentivesSalesForm }
          ]
        },

        // Existing incentives admin screens (kept as-is)
        {
          path: 'admin',
          name: 'admin',
          component: Admin,
          meta: { allowedRoles: BIRD_EYE_ROLES }
        },
        {
          path: 'admin/sale/:id',
          name: 'admin-sale-edit',
          component: AdminSaleEdit,
          props: true,
          meta: { allowedRoles: BIRD_EYE_ROLES }
        },
        {
          path: 'admin/branch-expenses',
          name: 'branch-expenses',
          component: BranchExpenses,
          meta: { allowedRoles: BIRD_EYE_ROLES, mode: 'incentives' }
        },

        // =========================
        // OPS (FINAL VISION)
        // =========================
        {
          path: 'ops/finance',
          name: 'ops-finance',
          component: function () { return import('./views/Ops/Finance.vue') },
          meta: { allowedRoles: OPS_FINANCE_ROLES }
        },
        {
          path: 'ops/dispatch',
          name: 'ops-dispatch',
          component: function () { return import('./views/Ops/Dispatch.vue') },
          meta: { allowedRoles: OPS_DISPATCH_ROLES }
        },
        {
          path: 'ops/installer',
          name: 'ops-installer',
          component: function () { return import('./views/Ops/Installer.vue') },
          meta: { allowedRoles: OPS_INSTALLER_ROLES }
        },

        {
          path: 'ops/finance/history',
          name: 'ops-finance-history',
          component: History,
          meta: { allowedRoles: OPS_FINANCE_ROLES }
        },
        {
          path: 'ops/dispatch/history',
          name: 'ops-dispatch-history',
          component: History,
          meta: { allowedRoles: OPS_DISPATCH_ROLES }
        },
        {
          path: 'ops/installer/history',
          name: 'ops-installer-history',
          component: History,
          meta: { allowedRoles: OPS_INSTALLER_ROLES }
        },

        // =========================
        // RM STORE (NO PORTAL WRAPPER)
        // =========================
        {
          path: 'ops/rm-store',
          redirect: 'ops/rm-store/dashboard',
          meta: { allowedRoles: OPS_RM_STORE_ROLES }
        },
        {
          path: 'ops/rm-store/dashboard',
          name: 'ops-rm-dashboard',
          component: function () { return import('./views/Ops/RmDashboard.vue') },
          meta: { allowedRoles: OPS_RM_STORE_ROLES }
        },
        {
          path: 'ops/rm-store/incoming',
          name: 'ops-rm-incoming',
          component: function () { return import('./views/Ops/RmIncoming.vue') },
          meta: { allowedRoles: OPS_RM_STORE_ROLES }
        },
        {
          path: 'ops/rm-store/outgoing',
          name: 'ops-rm-outgoing',
          component: function () { return import('./views/Ops/RmOutgoing.vue') },
          meta: { allowedRoles: OPS_RM_STORE_ROLES }
        },
        // Optional: keep old URL working
        {
          path: 'ops/rm-store/add-stock',
          redirect: 'ops/rm-store/incoming',
          meta: { allowedRoles: OPS_RM_STORE_ROLES }
        }



      ]
    },

    { path: '/', redirect: '/portal' },
    { path: '*', redirect: '/portal' }
  ]
})

// ---- Route guards (same style as yours) ----
router.beforeEach(function (to, from, next) {
  // Look through ALL matched route records (parent + child)
  var requiresAuth = to.matched.some(function (r) {
    return r.meta && r.meta.requiresAuth
  })

  // Find the nearest allowedRoles (deepest route that defines it)
  var allowedRoles = null
  for (var i = to.matched.length - 1; i >= 0; i--) {
    if (to.matched[i].meta && to.matched[i].meta.allowedRoles) {
      allowedRoles = to.matched[i].meta.allowedRoles
      break
    }
  }

  var user = store.getters['auth/currentUser']
  var authed = store.getters['auth/isAuthenticated']

  // If trying to access protected area and not logged in -> login
  if (requiresAuth && !authed) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // ✅ IMPORTANT: if we "look logged in" but user/role isn't ready, stop the loop
  if (requiresAuth && authed && (!user || !user.role)) {
    // safest: force re-login (prevents infinite redirects)
    store.dispatch('auth/logout')
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // Optional: if already logged in and visiting login -> go home
  if (to.path === '/login' && authed) {
    return next(roleHomePath(user && user.role))
  }

  // Role gate
  if (allowedRoles && user && allowedRoles.indexOf(user.role) === -1) {
    return next(roleHomePath(user.role))
  }

  return next()
})


export default router
